import React from 'react';

export interface ICheckboxCommonProps {
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    wrapped?: boolean;
    disabled?: boolean;
}

interface ICheckboxBaseProps extends ICheckboxCommonProps {
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: boolean;
}

const CheckboxBase: React.FC<ICheckboxBaseProps> = (props) => {
    const id = props.name ? props.name : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    const input = (
        <div style={{ display: 'inline-block' }}>
            <input
                className={`dlc-form-checkbox ${props.disabled ? 'disabled' : ''}`}
                id={id}
                type="checkbox"
                onChange={props.onChange}
                checked={props.value}
                disabled={props.disabled}
            />
            <label className={props.wrapped ? 'dlc-form-checkbox-wrapped-label' : `${props.className}`} htmlFor={id}>
                <span className={props.disabled ? 'text-muted' : ''}>{props.label}</span>
            </label>
        </div>
    );

    if (props.wrapped) {
        return (
            <div className={`dlc-form-checkbox-wrapped`} style={props.style}>
                <div className="dlc-form-checkbox-wrapped-inner">{input}</div>
            </div>
        );
    } else {
        return <div style={{ margin: '.5rem 0 1rem 0', ...props.style }}>{input}</div>;
    }
};

export default CheckboxBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/CheckboxBase.tsx